import HeroSection3 from '../Components/HeroSection3/index3'
import Footer from '../Components/Footer/Footer'
import Card2 from '../Components/Card_event/Card2'
import ScrollToTop from '../Components/ScrollToTop'
import InfoSection2 from '../Components/Infosection2/Index2'
import { homeObjOne2 } from '../Components/Infosection2/Data2'

const Event = () => {
  return (
    <>
      <ScrollToTop />
      <HeroSection3 />
      <InfoSection2 {...homeObjOne2} />
      <Card2 />
      <Footer />
    </>
  )
}

export default Event